<template>
  <vx-card title="All Cameras" class="shadow-md">
      <div slot="actions">
      <vs-input
          label="Enter Ip Address"
          
          name="Name"
          v-model="ip"
          class="mt-5 w-full mb-3"
        />

        <vs-button
                    class="mr-6"
                    color="success"
                    type="gradient"
                    @click="getCameras()"
                    >Save</vs-button
                  >

      
    </div>
    <vs-tabs alignment="center" v-model="myval" color="primary">
      <vs-tab label="Locations">
        <div>
          <gmap-map
            :center="center"
            :map-type-id="mapType"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }"
            :zoom="zoom"
            @zoom_changed="update('zoom', $event)"
            style="width: 100%; height: 600px"
          >
            <gmap-marker
              :key="i"
              v-for="(m, i) in cameras"
              :position="m.coordinates"
              :label="m.label"
              :icon="m.icon"
              :clickable="true"
              @click="toggleInfoWindow(m, i)"
            ></gmap-marker>
          </gmap-map>
        </div>
      </vs-tab>
      <vs-tab label="Media">
        <div class="vx-row">
          <!-- CARD 4: SESSION -->
          <div class="vx-col w-full md:w-1/2 mb-base">
            <vx-card>
              <div class="vx-row">
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 self-center"
                >
                  <vs-select
                    autocomplete
                    label="Select Camera"
                    class=" w-full"
                    @change="changeStream()"
                    v-model="selectedCameraRecord"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in cameras"
                    />
                  </vs-select>
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 self-center"
                >
                  <vs-button
                    class="mr-6"
                    color="dark"
                    type="gradient"
                    @click="toggle"
                    >View Full Screen</vs-button
                  >
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 self-center"
                >
                  <h5>
                    Camera Status:
                    <strong
                      v-if="singleCameraName.linkStatus == true"
                      class="text-success"
                      >Online</strong
                    >
                    <strong v-else class="text-danger">Offline</strong>
                  </h5>
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 self-center"
                >
                  <h5>
                    Recording Status:
                    <strong
                      v-if="singleCameraName.recordingStatus == true"
                      class="text-success"
                      >Online</strong
                    >
                    <strong v-else class="text-danger">Offline</strong>
                  </h5>
                </div>
                <div
                  class="vx-col w-full mb-4 self-center"
                >
                  <fullscreen ref="fullscreen" @change="fullscreenChange">
                  
                  
      <img class=" h-full w-full rounded-lg object-cover" :src="cameraData" :alt="cameraDataAlt" >
    
                </fullscreen>
                </div>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-full md:w-1/2 mb-base">
            <vx-card>
              <div class="vx-row">
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 mx-auto self-center"
                >
                  <p>Select Start Date:</p>
                  <datetime
                    type="datetime"
                    id="1"
                    input-class="vs-inputx vs-input--input normal"
                    v-model="selectedTimeStart"
                  ></datetime>
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 mx-auto self-center"
                >
                  <p>Select End Date:</p>
                  <datetime
                    type="datetime"
                    id="2"
                    input-class="vs-inputx vs-input--input normal"
                    v-model="selectedTimeEnd"
                  ></datetime>
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 self-center"
                >
                  <vs-select
                    autocomplete
                    label="Select Camera"
                    class=" w-full"
                    v-model="selectedCameraRecord"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in cameras"
                    />
                  </vs-select>
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mt-2  self-center text-center"
                >
                  <vs-button
                    class="mr-6"
                    color="success"
                    type="gradient"
                    @click="getCameraRecord()"
                    >{{ buttonText }}</vs-button
                  >
                </div>
              </div>
              <vs-table
                ref="table"
                pagination
                :max-items="itemsPerPage"
                search
                :data="cameraRecords"
              >
                <div
                  slot="header"
                  class="flex flex-wrap-reverse items-center flex-grow justify-between"
                >
                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown
                    vs-trigger-click
                    class="cursor-pointer mb-4 mr-4"
                  >
                    <div
                      class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                      <span class="mr-2"
                        >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                        {{
                          cameraRecords.length - currentPage * itemsPerPage > 0
                            ? currentPage * itemsPerPage
                            : cameraRecords.length
                        }}
                        of {{ cameraRecords.length }}</span
                      >
                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4"
                      />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage = 4">
                        <span>4</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <template slot="thead">
                  <vs-th sort-key="name">Name</vs-th>
                  <vs-th sort-key="category">Download</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>
                        <p class="product-name font-medium">{{ tr.name }}</p>
                      </vs-td>

                      <vs-td>
                        <!-- <p class="product-category">{{ tr.mediaUrl }}</p> -->
                        <vs-button
                          class="m-2"
                          icon-pack="feather"
                          icon="icon-download"
                          color="dark"
                          icon-after
                          @click="downloadVideo(tr.mediaUrl)"
                          >Download</vs-button
                        >
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      myval: 0,
      cameras: [],
      center: { lat: 22.5768225, lng: 88.432745 },
      zoom: 15,
      buttonText: "Get Records",
      mapType: "satellite",
      fullscreen: false,
      ip:"",
      defaultFPS: 20,
      isMounted: false,
      bottomNav: 0,
      itemsPerPage: 4,
      isDisabled: false,
      cameraData: require(`@/assets/demo-screen.png`),
      cameraDataAlt: require(`@/assets/demo-screen.png`),
      selectedCamera: "",
      selectedCameraDetails: "",
      showCameraDetails: false,
      isLoading: false,
      fullPage: true,
      overlay: false,
      imageHeight: 4 / 3,
      editedIndex: -1,
      headers: [
        {
          text: "File Name",
          value: "mediaUrl",
          align: "center",
          sortable: false
        },
        { text: "Download", value: "name", sortable: false, align: "center" }
      ],
      endPoint: "45.64.237.125:58304",
      endPointWs: "45.64.237.125:56000",
      selectedTimeStart: moment()
        .subtract(5, "hours")
        .format("YYYY-MM-DDTHH:mm:ss"),
      selectedTimeEnd: moment().format("YYYY-MM-DDTHH:mm:ss"),
      singleCameraName: "",
      selectedCameras: "",
      selectedCameraRecord: "",
      cameraRecords: [],
      orientationType: "",
      screenTypePrimary: ""
    };
  },
  created() {
    this.getCameras();
    this.orientationType = screen.orientation.type;
    var self = this;
    window.addEventListener(
      "orientationchange",
      function() {
        // Announce the new orientation number
        console.log(screen.orientation.type);
        self.orientationType = screen.orientation.type;
        console.log(self.screenTypePrimary);
        if (self.orientationType == "landscape-primary") {
          console.log(self.fullscreen);
          if (self.$mq == "mobile" && self.fullscreen == true) {
            self.imageHeight = 4 / 2;
          }
        } else {
          if (self.$mq == "mobile" && self.fullscreen == true) {
            self.imageHeight = 2 / 4;
          }
          if (self.screenTypePrimary == "mobile") {
            if (self.$mq == "tablet" && self.fullscreen == true) {
              self.imageHeight = 2 / 4;
            }
          }
        }
      },
      false
    );
    //var origin = window.location.origin;
    ///this.endpoint = origin;
    window.addEventListener("beforeunload", this.stopCurrentStream);
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    }
  },
  methods: {
    getCameras() {
      var self = this;
      self.cameras = [];
      var endpoint = ""
      if (this.ip == ""){
          endpoint = this.endPoint
      }else{
          endpoint = this.ip+":58304"
      }
      var locationList = [
        { lat: 22.571863, long: 88.433364, name: "Merlin Matrix" },
        { lat: 22.5768225, long: 88.432745, name: "Rashmi Tower indoor" },
        { lat: 22.572798, long: 88.43483, name: "College More indoor" },
        { lat: 22.579865, long: 88.43475, name: "BN block" }
      ];
      this.$http.get("http://" + endpoint + "/getCameras").then(
        (response) => {
          var res = response.data;
          for (var x in res) {
            res[x].name = res[x].cameraName.toUpperCase();
            res[x].id = res[x].cameraID;
            res[x].icon = {
              url: require(`@/assets/street-light.png`),
              size: { width: 64, height: 64, f: "px", b: "px" },
              scaledSize: { width: 54, height: 54, f: "px", b: "px" },
              labelOrigin: { x: 20, y: 50 }
            };
            res[x].label = {
              color: "black",
              fontWeight: "bold",
              fontSize: "16px",
              text: res[x].name
            };
            res[x].coordinates = {
              lat: locationList[x].lat,
              lng: locationList[x].long
            };
            this.cameras.push(res[x]);
          }
          var data = response.data;
          //this.singleCameraName = data[0].name;
          this.selectedCameras = data[0].cameraID;
          this.selectedCameraRecord = data[0].cameraID;
        },
        (error) => {
          console.log(this.networkError);
        }
      );
    },
    update(field, event) {
      this.$set(this, field, event);
    },
    getCameraRecord() {
      var cameras = this.cameras;
      var endpoint = ""
      if (this.ip == ""){
          endpoint = this.endPoint
      }else{
          endpoint = this.ip+":58304"
      }
      this.isMounted = true;
      function getName(id) {
        for (var m in cameras) {
          if (cameras[m].id == id) {
            return cameras[m].name;
          }
        }
      }
      var startTime = this.selectedTimeStart;
      startTime = moment(startTime).valueOf();
      var endTime = this.selectedTimeEnd;
      endTime = moment(endTime).valueOf();
      var cameraId = this.selectedCameraRecord;
      var cameraname = getName(cameraId);
      this.$http
        .get(
          "http://" +
            endpoint +
            "/getRecord?cam_id=" +
            cameraId +
            "&start=" +
            startTime +
            "&end=" +
            endTime
        )
        .then(
          (response) => {
            var record = [];
            var data = response.data;
            for (var m in data) {
              var startTime = moment(data[m].startTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              var endTime = moment(data[m].endTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              data[m].name =
                cameraname.toUpperCase() +
                ": From " +
                startTime +
                " to " +
                endTime;
            }
            this.cameraRecords = [];
            this.cameraRecords = data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    downloadVideo(downloadUrl) {
        var endpoint = ""
      if (this.ip == ""){
          endpoint = this.endPoint
      }else{
          endpoint = this.ip+":58304"
      }
      var url =
        "http://" + endpoint + "/fileDownload?fileName=" + downloadUrl;
      window.open(url);
      // this.$http.get('http://'+this.endPoint+'/fileDownload?fileName='+downloadUrl).then(response =>{
      //     console.log(response.body)

      // },error => {
      //   console.log(error)
      // })
    },
    toggleInfoWindow: function(marker, idx) {
      this.center = marker.coordinates;
      this.showCameraDetails = true;
      this.selectedCameraDetails = marker;
      this.isLoading = true;
      this.selectedCameraRecord = marker.id;
      this.myval = 1;
      this.showVideoStream(marker);
    },
    showVideoStream(data) {
      var endpoint = ""
      if (this.ip == ""){
          endpoint = this.endPointWs
      }else{
          endpoint = this.ip+":56000"
      }  
      this.screenTypePrimary = this.$mq;
      console.log(this.screenTypePrimary);
      var self = this;

      this.singleCameraName = data;
      this.cameraData =
        "http://" +
        endpoint +
        "/videostream?camid=" +
        data.cameraID +
        "&fps=" +
        this.defaultFPS;
      self.isLoading = false;
    },
    changeStream() {
      var cameraData = this.cameras;
      var data = "";
      for (var m in cameraData) {
        if (cameraData[m].id == this.selectedCameraRecord) {
          data = cameraData[m];
        }
      }

      this.toggleInfoWindow(data);
    },
    toggle() {
      console.log("checking");
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      if (this.$mq == "desktop" && fullscreen == true) {
        console.log("is desktop");
        this.imageHeight = 16 / 9;
      } else if (this.$mq == "mobile" && fullscreen == true) {
        console.log("is mobile");
        if (this.orientationType == "portrait-primary") {
          this.imageHeight = 2 / 4;
        }
        // this.imageHeight = 4 / 3;
      } else if (this.$mq == "tablet" && fullscreen == true) {
        console.log("tablet");
        if (this.screenTypePrimary == "mobile") {
          this.imageHeight = 4 / 2;
        } else {
          this.imageHeight = 4 / 3;
        }
      } else if (this.$mq == "laptop" && fullscreen == true) {
        console.log("laptop");
        this.imageHeight = 16 / 9;
      } else {
        this.imageHeight = 4 / 3;
      }

      this.fullscreen = fullscreen;
    }
  }
};
</script>
<style lang="scss">
.vs-tabs-primary button:not(:disabled):hover {
  color: rgba(var(--vs-primary), 1) !important;
}
</style>
